import React from 'react';

/**
 * A single check-box that, when checked, expands to reveal additional
 * fields. Used by all three life-event update sections.
 *
 * @param {string}   id
 * @param {string}   label    - Visible checkbox label.
 * @param {boolean}  checked
 * @param {function} onChange - Called with the new boolean value.
 * @param {React.ReactNode} children - Conditional details to render.
 */
export default function LifeEventCheckbox({ id, label, checked, onChange, children }) {
  return (
    <div className={`p-3 mb-2 border rounded ${checked ? 'bg-light border-danger' : 'bg-white'}`}>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={id}
          checked={!!checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <label className="form-check-label fw-semibold" htmlFor={id}>
          {label}
        </label>
      </div>
      {checked && children && (
        <div className="mt-3 ps-4 border-start border-2 border-danger-subtle">
          {children}
        </div>
      )}
    </div>
  );
}
